import { NotifyHelper } from "../../../helpers/toast";
import { eThoiKhoaBieuActionsObj } from "../../action-types/tkb/IThoiKhoaBieuActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const thoiKhoaBieuActions = {
  ...generateActions(eThoiKhoaBieuActionsObj, "THOI_KHOA_BIEU"),
  ...generateActionForKey(eThoiKhoaBieuActionsObj, "THOI_KHOA_BIEU", "SELECT_BY_KY_DANG_KY_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
